import {ViewOptions} from 'backbone';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {MenuChoicesOptions} from 'components/SelectionContextMenuHelpers';
import {Sequence} from 'components/Sequence';
import PolymerAnnotationsView, {
  PolymerAnnotationsOptions,
  PolymerAnnotationsViewModel,
} from 'molbio/maps/linear/PolymerAnnotationsView';
import TranslationAsAnnotation, {
  getTranslationsAsAnnotationsInRange,
} from 'molbio/translations/backbone/TranslationAsAnnotation';
import * as vo from 'settings/visibility-options/VisibilityOptions';

/**
 * Translations view for use on the linear map. Rather than building a custom UI, we're using
 * the same render logic as annotations.
 */
export default class TranslationsAsAnnotationsView extends PolymerAnnotationsView<
  Sequence,
  PolymerAnnotationsViewModel<Sequence>,
  TranslationAsAnnotation
> {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(...args: Array<any>) {
    super(...args);
    this.className = 'translations';
  }

  initialize(options: ViewOptions<PolymerAnnotationsViewModel<Sequence>> & PolymerAnnotationsOptions): void {
    this.setting = vo.TRANSLATIONS.name;
    super.initialize(options);
  }

  contextMenuOptions(): Array<string> {
    return selectioncontextmenu.TRANSLATION_BASE_MENU;
  }
  contextMenuData(d: TranslationAsAnnotation): MenuChoicesOptions {
    return {
      translation: d.get('translationComponentModel'),
    };
  }

  getData(start: number, end: number): Array<TranslationAsAnnotation> {
    const {numTotal, numVisible, numShown, shownTranslations} = getTranslationsAsAnnotationsInRange(
      this.model.polymer(),
      start,
      end
    );
    this.model.set({
      totalTranslations: numTotal,
      visibleTranslations: numVisible,
      shownTranslations: numShown,
    });
    return shownTranslations;
  }

  _registerAnnotationListeners(): void {
    const sequence = this.model.polymer();
    this.listenTo(sequence.translations(), 'change', () => {
      this.update();
    });
  }
}
